// Function to update the free shipping notice based on the cart total
function updateFreeShippingNotice(cartTotal) {
  var freeShippingNotice = jQuery(".free_shipping_notice");
  var priceAway = freeShippingNotice.find(".priceAway");

  // Replace 30 with your free shipping threshold
  var freeShippingThreshold = 30;

  if (cartTotal >= freeShippingThreshold) {
    freeShippingNotice.hide();
  } else {
    var remainingAmount = freeShippingThreshold - cartTotal;
    priceAway.text("$" + remainingAmount.toFixed(2));
    freeShippingNotice.show();
  }
}

// Document ready
jQuery(document).ready(function ($) {
  // Initial update
  var initialCartTotal = parseFloat(
    $(".totals__total-value").text().replace("$", "").replace(" CAD", "")
  );
  updateFreeShippingNotice(initialCartTotal);

  // Listen for Shopify cart update events
  $(document).on("ajaxCart.afterCartLoad", function (event, cart) {
    // Assuming the cart object has a total_price property
    var updatedCartTotal = cart.total_price / 100; // Convert to dollars
    updateFreeShippingNotice(updatedCartTotal);
  });

  // Block the input of + and -
  $('.quantity__input, [name="quantity"]').on("keydown", function (e) {
    if (e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  });
});

jQuery(document).ready(function ($) {
  if (window.location.href.indexOf("/challenge") > -1) {
    // Scroll to the element with ID "g-recaptcha"
    $("html, body").animate(
      {
        scrollTop: $("#g-recaptcha").offset().top,
      },
      1000
    ); // Adjust the duration as needed
  }

  $("#beforeLoad").appendTo("#afterLoad");

  $(".left-arrow-icon").on("click", function () {
    $(".product-list-carousel .pf-slider-prev").trigger("click");
  });
  $(".right-arrow-icon").on("click", function () {
    $(".product-list-carousel .pf-slider-next").trigger("click");
  });

  setInterval(function () {
    price_slider();
  }, 1500);

  price_slider();

  // function price_slider(){
  //   var rangeInput = document.querySelectorAll(".facets-container .range-input input"),
  //   priceInput = document.querySelectorAll(".facets-container .facets__price .field input"),
  //   range = document.querySelector(".facets-container .slider .progress");
  //   var priceGap = 1;

  //   rangeInput.forEach((input) => {
  //     input.addEventListener("input", (e) => {
  //       console.log(rangeInput[0].value,"And", rangeInput[1].value);

  //       let minVal = parseInt(rangeInput[0].value),
  //         maxVal = parseInt(rangeInput[1].value);

  //       if (maxVal - minVal < priceGap) {
  //         if (e.target.className === "range-min") {
  //           rangeInput[0].value = maxVal - priceGap;
  //         } else {
  //           rangeInput[1].value = minVal + priceGap;
  //         }
  //       } else {
  //         priceInput[0].value = minVal;
  //         priceInput[1].value = maxVal;
  //         range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
  //         range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
  //       }
  //     });
  //   });
  // }

  function price_slider() {
    const rangeInputs = document.querySelectorAll(".range-input input"),
      priceInputs = document.querySelectorAll(".facets__price .field input"),
      range = document.querySelector(".slider .progress");
    let priceGap = 1;
    rangeInputs.forEach((input) => {
      input.addEventListener("input", updatePriceRange);
    });
    priceInputs.forEach((input) => {
      input.addEventListener("input", updatePriceRange);
    });
    function updatePriceRange() {
      let minVal = parseFloat(rangeInputs[0].value),
        maxVal = parseFloat(rangeInputs[1].value);
      if (maxVal - minVal < priceGap) {
        if (document.activeElement === priceInputs[0]) {
          // If the first price input is being edited
          rangeInputs[0].value = maxVal - priceGap;
        } else if (document.activeElement === priceInputs[1]) {
          // If the second price input is being edited
          rangeInputs[1].value = minVal + priceGap;
        }
      } else {
        priceInputs[0].value = minVal;
        priceInputs[1].value = maxVal;
        range.style.left = (minVal / rangeInputs[0].max) * 100 + "%";
        range.style.right = 100 - (maxVal / rangeInputs[1].max) * 100 + "%";
      }
    }
  }

  $(".range-max").on("change", function (e) {});
});

// ==========================================================================================

// Get all elements with the class "q-add-btn"
var addButtons = document.getElementsByClassName("q-add-btn");

// Add click event listeners to each button
for (var i = 0; i < addButtons.length; i++) {
  addButtons[i].addEventListener("click", function () {
    // Get the product URL from the data attribute
    var productUrl = this.getAttribute("data-product-url");

    // Redirect to the product URL
    // window.location.href = productUrl;
  });
}

// ==========================================================================================

jQuery(document).ready(function ($) {
  // Assuming your TabsMenu items are buttons with data-pf-type=TabHeader2
  $("button[data-pf-type=TabHeader2]").click(function () {
    var position = $(this).position();
    var scroll = $("div[data-pf-type=TabsMenu]").scrollLeft();

    $("div[data-pf-type=TabsMenu]").animate(
      {
        scrollLeft: scroll + position.left - 30,
      },
      200
    );
  });

  setTimeout(function () {
    if (
      $("#belTitleRev .loox-rating").find(".loox-rating-content").length == 0
    ) {
      $("#revImg").show();
    }
  }, 2000);
  $("#belTitleRev").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("#revSec").offset().top,
      },
      500
    );
  });
});

// ==========================================================================================

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const isAlreadySubscribed =
    urlParams.get("contact[tags]") === "newsletter" &&
    urlParams.get("form_type") === "customer";

  if (isAlreadySubscribed) {
    const alreadySubscribedMessage = document.querySelector(
      ".already-subscribed"
    );
    const newsletterForm = document.querySelector(".newsletter-form");

    if (
      alreadySubscribedMessage &&
      newsletterForm &&
      !newsletterForm.innerHTML.includes("ContactFooter-error")
    ) {
      alreadySubscribedMessage.style.display = "flex";
    }
  }
});

//===========================================================================================

jQuery(document).ready(function ($) {
  if (window.innerWidth <= 980) {
    $(".mobSlider > div > div").slick({
      infinite: true,
      autoplay: true,
      arrows: false,
      slidesToShow: 2, // Show 2 items on tablets
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // Breakpoint for tablets and below
          settings: {
            slidesToShow: 1, // Show 1 item on mobile
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".home-video-section-wy").slick({
      infinite: true,
      autoplay: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, 
          settings: {
            slidesToShow: 1, 
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".aboutSlider").slick({
      infinite: true,
      autoplay: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, 
          settings: {
            slidesToShow: 1, 
            slidesToScroll: 1,
          },
        },
      ],
    });
      $('.slick-slide img').removeAttr('loading');
  }
});




// ==========================================

